import CustomerEditModal from "../components/CustomerEditModal";
import imageCompression from "browser-image-compression";
import React, { useState, useEffect, useRef } from 'react';
import VINScanner from '../components/VINScanner';
import StepProgress from '../components/StepProgress';
import V5CRedactor from '../components/V5CRedactor';
import { sendJobEmail } from '../services/api';
import SubscriptionTab from '../components/SubscriptionTab';
import KnowledgeBase from '../components/KnowledgeBase';

interface TechnicianPortalProps {
  token: string;
  onLogout: () => void;
}

const TechnicianPortal: React.FC<TechnicianPortalProps> = ({ token, onLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [jobs, setJobs] = useState<any[]>([]);
  const [customers, setCustomers] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profile, setProfile] = useState({ first_name: '', last_name: '', email: '', phone: '' });
  const [passwordData, setPasswordData] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [profileMessage, setProfileMessage] = useState('');
  const [companySettings, setCompanySettings] = useState({ company_name: '', company_address: '', company_phone: '', company_email: '', vat_number: "", vat_registered: false, company_reg_number: "", company_logo: "", bank_account_name: "", bank_sort_code: "", bank_account_number: "", bank_account_ref: "" })

  const loadCompanySettings = async () => {
    try {
      const res = await fetch('/api/company/settings', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setCompanySettings(await res.json());
    } catch (e) { console.error(e); }
  };
  const [profileError, setProfileError] = useState('');
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [emailSending, setEmailSending] = useState(false);
  const [emailMessage, setEmailMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const [currentEmailJob, setCurrentEmailJob] = useState<any>(null);
  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const [showCustomerEditModal, setShowCustomerEditModal] = useState(false);
  const [showJobEditModal, setShowJobEditModal] = useState(false);
  const [editingJob, setEditingJob] = useState<any>(null);
  const [editJobData, setEditJobData] = useState({ customer_name: '', company_name: '', address: '', region: '', postcode: '', customer_type: 'domestic', vehicle_reg: '', service_type: '', quantity: 1, issue: '', price: 0, status: 'pending', job_type: 'vehicle' });
  const [editingCustomer, setEditingCustomer] = useState<any>(null);
  const [newCustomer, setNewCustomer] = useState({ first_name: '', surname: '', email: '', mobile_tel: '', company_name: '', company_tel: '', postcode: '', address: '', addr_line1: '', addr_line2: '', addr_city: '', addr_county: '' });
  const [isMobile, setIsMobile] = useState(false);
  const [managedServices, setManagedServices] = useState<any[]>([]);
  const [dashboardStats, setDashboardStats] = useState({ totalJobs: 0, completedJobs: 0, pendingJobs: 0, closedJobs: 0, sermiJobs: 0, totalRevenue: 0, monthlyRevenue: 0, totalCustomers: 0, recentJobs: [] });

  // SERMI States
  const [currentStep, setCurrentStep] = useState(1);
  const [newJob, setNewJob] = useState({
    job_type: 'vehicle',
    customer_name: '',
    customer_email: '',
    customer_phone: '',
    company_name: '',
    address: '',
    region: '',
    postcode: '',
    addr_line1: '',
    addr_line2: '',
    addr_city: '',
    addr_county: '',
    country: 'UK',
    customer_type: 'domestic',
    vehicle_reg: '',
    vehicle_make: '',
    vehicle_model: '',
    vehicle_colour: '',
    service_type: '',
    quantity: 1,
    issue: '',
    vehicle_vin: '',
    is_sermi: false,
    keeper_name: '',
    keeper_address: '',
    price: undefined as number | undefined
  });
  const [v5cImage, setV5cImage] = useState<string | null>(null);
  const [v5cFile, setV5cFile] = useState<File | null>(null);
  const [v5cUploading, setV5cUploading] = useState(false);
  const [showV5CRedactor, setShowV5CRedactor] = useState(false);
  const [showPhotoIdRedactor, setShowPhotoIdRedactor] = useState(false);
  const [photoIdImage, setPhotoIdImage] = useState<string | null>(null);
  const [photoIdFile, setPhotoIdFile] = useState<File | null>(null);
  const [photoIdUploading, setPhotoIdUploading] = useState(false);
  const [photoIdType, setPhotoIdType] = useState('driving_licence');
  const [photoIdNumber, setPhotoIdNumber] = useState('');
  const [jobSource, setJobSource] = useState('private_customer');
  const [mileage, setMileage] = useState('');
  const [vinLocation, setVinLocation] = useState('');
  const [vinMatchesV5c, setVinMatchesV5c] = useState<boolean | null>(null);
  const [idName, setIdName] = useState('');
  const [idVerifiedBy, setIdVerifiedBy] = useState('');
  const [authorityCompanyName, setAuthorityCompanyName] = useState('');
  const [authorityContactName, setAuthorityContactName] = useState('');
  const [authorityContactEmail, setAuthorityContactEmail] = useState('');
  const [authorityCompanyAddress, setAuthorityCompanyAddress] = useState('');
  const [authorityCompanyPhone, setAuthorityCompanyPhone] = useState('');
  const [driverIdType, setDriverIdType] = useState('');
  const [driverIdReference, setDriverIdReference] = useState('');
  const [extraPhotos, setExtraPhotos] = useState<string[]>([]);
  const [extraPhotoFiles, setExtraPhotoFiles] = useState<File[]>([]);
  const [signatureData, setSignatureData] = useState<string | null>(null);
  const [signatureName, setSignatureName] = useState('');
  const [signatureDate, setSignatureDate] = useState(new Date().toISOString().split('T')[0]);
  const [isDrawing, setIsDrawing] = useState(false);
  const [techSignatureData, setTechSignatureData] = useState<string | null>(null);
  const [techSigName, setTechSigName] = useState('');
  const [techIsDrawing, setTechIsDrawing] = useState(false);
  const signaturePadRef = useRef<HTMLCanvasElement>(null);
  const techSignaturePadRef = useRef<HTMLCanvasElement>(null);

  // Online status (cloud sync indicator)
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    const ping = async () => {
      try {
        const res = await fetch('/api/jobs', { headers: { Authorization: 'Bearer ' + token } });
        setIsOnline(res.ok);
      } catch { setIsOnline(false); }
    };
    const iv = setInterval(ping, 30000);
    ping();
    return () => { window.removeEventListener('online', goOnline); window.removeEventListener('offline', goOffline); clearInterval(iv); };
  }, [token]);

  // Reset wizard to step 1 whenever the new-job modal opens
  useEffect(() => { if (showModal) setCurrentStep(1); }, [showModal]);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Load data
  const loadData = async () => {
    try {
      const [jobsRes, customersRes] = await Promise.all([
        fetch('/api/jobs', { headers: { Authorization: `Bearer ${token}` } }),
        fetch('/api/customers', { headers: { Authorization: `Bearer ${token}` } })
      ]);
      if (jobsRes.ok) {
        const jobsData = await jobsRes.json();
        setJobs(jobsData);
      }
      if (customersRes.ok) setCustomers(await customersRes.json());
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadData(); loadDashboard(); loadManagedServices(); loadCompanySettings(); }, []);

  const loadManagedServices = async () => {
    try {
      const res = await fetch('/api/services', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setManagedServices(await res.json());
    } catch (e) {}
  };

  const loadDashboard = async () => {
    try {
      const res = await fetch('/api/dashboard/stats', { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) setDashboardStats(await res.json());
    } catch (err) { console.error(err); }
  };

  const loadProfile = async () => {
    try {
      const res = await fetch('/api/auth/profile', { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        setProfile({ first_name: data.first_name || '', last_name: data.last_name || '', email: data.email || '', phone: data.phone || '' });
      }
    } catch (err) { console.error(err); }
  };

    // Image capture with compression - works on mobile
  const captureImage = (type: 'v5c' | 'photo_id' | 'extra') => {
    const input = document.createElement('input');
    input.type = 'file';
    // Use camera on mobile, works on both iOS Safari and Android Chrome
    input.setAttribute('capture', 'environment');
    // Broad accept for Android compatibility
    input.setAttribute('accept', 'image/*');
    
    input.onchange = async (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;
      
      console.log(`📸 Original ${type}: ${(file.size / 1024 / 1024).toFixed(2)} MB`);
      
      // Show loading
      if (type === 'v5c') {
        setV5cUploading(true);
      } else if (type === 'photo_id') {
        setPhotoIdUploading(true);
      }
      
      try {
        // Create preview URL
        const previewUrl = URL.createObjectURL(file);
        if (type === 'v5c') {
          setV5cImage(previewUrl);
        } else if (type === 'extra') {
          setExtraPhotos(prev => [...prev, previewUrl]);
        } else {
          setPhotoIdImage(previewUrl);
        }
        
        // Compress image
        const options = {
          maxSizeMB: 0.8,
          maxWidthOrHeight: 1024,
          useWebWorker: false, // Set to false for better mobile compatibility
          fileType: 'image/jpeg'
        };
        
        const compressedFile = await imageCompression(file, options);
        console.log(`📦 Compressed ${type}: ${(compressedFile.size / 1024).toFixed(0)} KB`);
        
        if (type === 'v5c') {
          setV5cFile(compressedFile);
        } else if (type === 'extra') {
          setExtraPhotoFiles(prev => [...prev, compressedFile]);
        } else {
          setPhotoIdFile(compressedFile);
        }
      } catch (err) {
        console.error('Compression error:', err);
        // Fallback: use original file without compression
        if (type === 'v5c') {
          setV5cFile(file);
        } else if (type === 'extra') {
          setExtraPhotoFiles(prev => [...prev, file]);
        } else {
          setPhotoIdFile(file);
        }
      } finally {
        if (type === 'v5c') {
          setV5cUploading(false);
        } else if (type === 'photo_id') {
          setPhotoIdUploading(false);
        }
      }
    };
    input.click();
  };

  const removeImage = (type: "v5c" | "photo_id") => {
    if (type === "v5c") {
      setV5cImage(null);
      setV5cFile(null);
    } else {
      setPhotoIdImage(null);
      setPhotoIdFile(null);
    }
  };

  // Upload image to server
  const handleRedactedV5C = (file: File, previewUrl: string, extractedFields?: any) => {
    setV5cFile(file);
    setV5cImage(previewUrl);
    setShowV5CRedactor(false);
    // Use sessionStorage fallback if no fields provided
    if (!extractedFields || Object.keys(extractedFields).length === 0) {
      try {
        const stored = sessionStorage.getItem('locktrak_v5c_fields');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed.vin || parsed.reg || parsed.make || parsed.keeper_name) {
            extractedFields = parsed;
          }
        }
      } catch(e) {}
    }
    if (extractedFields) {
      const updates: any = {};
      if (extractedFields.vin) updates.vehicle_vin = extractedFields.vin;
      if (extractedFields.reg) updates.vehicle_reg = extractedFields.reg;
      if (extractedFields.make) updates.vehicle_make = extractedFields.make;
      if (extractedFields.model) updates.vehicle_model = extractedFields.model;
      if (extractedFields.colour) updates.vehicle_colour = extractedFields.colour;
      if (extractedFields.keeper_name) updates.customer_name = extractedFields.keeper_name;
      if (extractedFields.keeper_address) updates.address = extractedFields.keeper_address;
      if (Object.keys(updates).length > 0) {
        setNewJob(prev => ({...prev, ...updates}));

      }
    }
  };
  const handleRedactedPhotoId = (file: File, previewUrl: string, extractedFields?: any) => {
    setPhotoIdFile(file);
    setPhotoIdImage(previewUrl);
    setShowPhotoIdRedactor(false);
    if (!extractedFields || Object.keys(extractedFields).length === 0) {
      try {
        const stored = sessionStorage.getItem('locktrak_dl_fields');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed.surname || parsed.given_names || parsed.document_number) {
            extractedFields = parsed;
          }
        }
      } catch(e) {}
    }
    if (extractedFields) {
      const updates: any = {};
      if (extractedFields.surname || extractedFields.given_names) {
        updates.customer_name = ((extractedFields.given_names || '') + ' ' + (extractedFields.surname || '')).trim();
      }
      if (extractedFields.document_number) setPhotoIdNumber(extractedFields.document_number);
      if (Object.keys(updates).length > 0) setNewJob(prev => ({...prev, ...updates}));
    }
  };

  const uploadImageToServer = async (file: File, uploadType: string): Promise<string | null> => {
    console.log(`📤 Uploading ${uploadType}...`);
    console.log(`File name: ${file.name}`);
    console.log(`File size: ${(file.size / 1024).toFixed(2)} KB`);
    console.log(`File type: ${file.type}`);
    
    const formData = new FormData();
    formData.append("image", file);
    
    try {
      console.log(`Sending to /api/upload/${uploadType}`);
      const res = await fetch(`/api/upload/${uploadType}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      
      console.log(`Response status: ${res.status}`);
      
      if (res.ok) {
        const data = await res.json();
        console.log(`✅ Uploaded: ${data.url}`);
        return data.url;
      } else {
        const errorText = await res.text();
        console.error(`❌ Upload failed (${res.status}):`, errorText);
        return null;
      }
    } catch (err) {
      console.error("❌ Upload error:", err);
      return null;
    }
  };


  // Signature pads — initialise on mount and whenever the SERMI section is shown
  useEffect(() => {
    const initCanvas = (canvas: HTMLCanvasElement | null) => {
      if (!canvas) return;
      canvas.width = 400;
      canvas.height = 150;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
      }
    };
    initCanvas(signaturePadRef.current);
    initCanvas(techSignaturePadRef.current);
  }, [newJob.is_sermi]);

  const startDrawing = (e: React.TouchEvent | React.MouseEvent) => {
    setIsDrawing(true);
    const canvas = signaturePadRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    let clientX, clientY;
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    const x = (clientX - rect.left) * scaleX;
    const y = (clientY - rect.top) * scaleY;
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const draw = (e: React.TouchEvent | React.MouseEvent) => {
    if (!isDrawing) return;
    const canvas = signaturePadRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    let clientX, clientY;
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    const x = (clientX - rect.left) * scaleX;
    const y = (clientY - rect.top) * scaleY;
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const endDrawing = () => {
    setIsDrawing(false);
    const canvas = signaturePadRef.current;
    if (canvas) setSignatureData(canvas.toDataURL());
  };

const techStartDrawing = (e: React.TouchEvent | React.MouseEvent) => {
    setTechIsDrawing(true);
    const canvas = techSignaturePadRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    let clientX, clientY;
    if ('touches' in e) { clientX = e.touches[0].clientX; clientY = e.touches[0].clientY; }
    else { clientX = e.clientX; clientY = e.clientY; }
    const x = (clientX - rect.left) * scaleX;
    const y = (clientY - rect.top) * scaleY;
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x, y); ctx.stroke();
  };
  const techDraw = (e: React.TouchEvent | React.MouseEvent) => {
    if (!techIsDrawing) return;
    const canvas = techSignaturePadRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    let clientX, clientY;
    if ('touches' in e) { clientX = e.touches[0].clientX; clientY = e.touches[0].clientY; }
    else { clientX = e.clientX; clientY = e.clientY; }
    const x = (clientX - rect.left) * scaleX;
    const y = (clientY - rect.top) * scaleY;
    ctx.lineTo(x, y); ctx.stroke();
  };
  const techEndDrawing = () => {
    setTechIsDrawing(false);
    const canvas = techSignaturePadRef.current;
    if (canvas) setTechSignatureData(canvas.toDataURL());
  };
  const clearTechSignature = () => {
    const canvas = techSignaturePadRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) { ctx.fillStyle = 'white'; ctx.fillRect(0, 0, canvas.width, canvas.height); setTechSignatureData(null); }
    }
  };
  const clearSignature = () => {
    const canvas = signaturePadRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        setSignatureData(null);
      }
    }
  };

  // Create job with image uploads
  const createJob = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      let v5cUrl = null;
      let photoIdUrl = null;
      
      if (newJob.is_sermi) {
        if (v5cFile) {
          setV5cUploading(true);
          v5cUrl = await uploadImageToServer(v5cFile, 'v5c');
          setV5cUploading(false);
        }
        if (photoIdFile) {
          setPhotoIdUploading(true);
          photoIdUrl = await uploadImageToServer(photoIdFile, 'photoid');
          setPhotoIdUploading(false);
        }
      }
      
      // Upload extra photos and store real URLs
      const extraPhotoUrls: string[] = [];
      for (const file of extraPhotoFiles) {
        const url = await uploadImageToServer(file, 'extra');
        if (url) extraPhotoUrls.push(url);
      }

      const jobData = {
        job_type: newJob.job_type,
        customer_name: newJob.customer_name,
        customer_email: newJob.customer_email,
        customer_phone: newJob.customer_phone,
        address: newJob.address,
        postcode: newJob.postcode,
        company_name: newJob.company_name,
        customer_type: newJob.customer_type,
        service_type: newJob.service_type,
        quantity: newJob.quantity,
        country: newJob.region || newJob.country,
        gps_lat: gpsCoords?.lat || null,
        gps_lng: gpsCoords?.lng || null,
        vehicle_reg: newJob.vehicle_reg,
        vehicle_make: newJob.vehicle_make,
        vehicle_model: newJob.vehicle_model,
        issue: newJob.issue,
        is_sermi: newJob.is_sermi,
        price: newJob.price || 0,
        v5c_image_url: v5cUrl,
        photo_id_image_url: photoIdUrl,
        extra_photos: extraPhotoUrls.length > 0 ? JSON.stringify(extraPhotoUrls) : null,
        photo_id_type: photoIdType,
        photo_id_number: photoIdNumber,
        signature_url: signatureData,
        signature_name: signatureName,
        signature_date: signatureDate || new Date().toISOString().split('T')[0],
        technician_signature: techSignatureData,
        technician_name: techSigName,
        technician_signed_at: techSigName ? new Date().toISOString().split('T')[0] : null,
        vehicle_vin: newJob.vehicle_vin || null,
        vehicle_colour: newJob.vehicle_colour || null,
        job_source: jobSource,
        mileage: mileage ? parseInt(mileage) : null,
        vin_location: vinLocation || null,
        vin_matches_v5c: vinMatchesV5c,
        id_type: photoIdType,
        id_name: idName || null,
        id_reference: photoIdNumber || null,
        id_verified_by: idVerifiedBy || null,
        authority_type: jobSource === 'private_customer' ? 'customer_signature' : jobSource === 'remote_mobile' ? 'signed_work_order' : jobSource === 'fleet_rental_loan' ? 'fleet_authority' : jobSource === 'work_provider' ? 'work_provider_authority' : 'contractor_authority',
        authority_company_name: authorityCompanyName || null,
        authority_contact_name: authorityContactName || null,
        authority_contact_email: authorityContactEmail || null,
        authority_company_address: authorityCompanyAddress || null,
        authority_company_phone: authorityCompanyPhone || null,
        driver_id_type: driverIdType || null,
        driver_id_reference: driverIdReference || null
      };
      
      const res = await fetch('/api/jobs', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(jobData)
      });
      
      if (res.ok) {
        alert('Job created successfully!');
        resetForm();
        setShowModal(false);
        loadData();
      } else {
        const error = await res.text();
        alert('Failed to create job: ' + error);
      }
    } catch (err) {
      console.error(err);
      alert('Error creating job');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setCurrentStep(1);
    setNewJob({
      customer_name: '', customer_email: '', customer_phone: '', company_name: '', address: '', region: '', postcode: '', country: 'UK', customer_type: 'domestic', job_type: 'vehicle', vehicle_reg: '', vehicle_make: '', vehicle_model: '', vehicle_colour: '', vehicle_vin: '', service_type: '', quantity: 1, issue: '', is_sermi: false, keeper_name: '', keeper_address: '', addr_line1: '', addr_line2: '', addr_city: '', addr_county: '', price: undefined
    });
    setV5cImage(null); setV5cFile(null);
    setPhotoIdImage(null); setPhotoIdFile(null);
    setPhotoIdType('driving_licence'); setPhotoIdNumber('');
    setJobSource('private_customer');
    setMileage(''); setVinLocation(''); setVinMatchesV5c(null);
    setIdName(''); setIdVerifiedBy('');
    setAuthorityCompanyName(''); setAuthorityContactName(''); setAuthorityContactEmail(''); setAuthorityCompanyAddress(''); setAuthorityCompanyPhone('');
    setDriverIdType(''); setDriverIdReference('');
    setSignatureData(null); setSignatureName(''); setSignatureDate('');
    setTechSignatureData(null); setTechSigName('');
    clearSignature();
    clearTechSignature();
  };

  // Job actions
  const reopenJob = async (job: any) => {
    if (!window.confirm(`Reopen job #${job.job_number}?`)) return;
    try {
      const res = await fetch(`/api/jobs/${job.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ status: 'pending' })
      });
      if (res.ok) { loadData(); }
    } catch (e) { alert('Error reopening job'); }
  };

  const closeJob = async (job: any) => {
    if (!window.confirm(`Close job #${job.job_number}?`)) return;
    try {
      const res = await fetch(`/api/jobs/${job.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ status: 'closed' })
      });
      if (res.ok) { loadData(); }
    } catch (e) { alert('Error closing job'); }
  };

  const lockJob = async (job: any) => {
    if (!window.confirm('Lock this compliance record? It will be timestamped and read-only. Unlocking requires a reason (logged to the audit trail).')) return;
    try {
      const res = await fetch(`/api/jobs/${job.id}/lock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ status: 'completed' })
      });
      if (res.ok) { loadData(); setSelectedJob({ ...job, locked_at: new Date().toISOString(), status: 'completed' }); }
      else { const e = await res.text(); alert('Lock failed: ' + e); }
    } catch (e) { alert('Error locking job'); }
  };

  const unlockJob = async (job: any) => {
    const reason = window.prompt('Reason for unlocking this compliance record (required, logged to audit trail):');
    if (!reason || !reason.trim()) { alert('A reason is required to unlock.'); return; }
    try {
      const res = await fetch(`/api/jobs/${job.id}/unlock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ reason })
      });
      if (res.ok) { loadData(); setSelectedJob({ ...job, locked_at: null }); }
      else { const e = await res.text(); alert('Unlock failed: ' + e); }
    } catch (e) { alert('Error unlocking job'); }
  };

  const deleteJob = async (id: string) => {
    if (window.confirm('Delete this job?')) {
      await fetch(`/api/jobs/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      loadData();
    }
  };

  const openEmailDialog = (job: any) => {
    setCurrentEmailJob(job);
    setEmailAddress(job.customer_email || '');
    setShowEmailDialog(true);
  };

  const sendEmail = async () => {
    if (!emailAddress?.includes('@')) {
      setEmailMessage({ type: 'error', text: 'Valid email required' });
      return;
    }
    setEmailSending(true);
    try {
      const result = await sendJobEmail(currentEmailJob.id, emailAddress);
      if (result.success) {
        setEmailMessage({ type: 'success', text: `✓ Sent to ${emailAddress}` });
        setTimeout(() => { setShowEmailDialog(false); setEmailMessage(null); }, 2000);
      } else setEmailMessage({ type: 'error', text: result.error || 'Failed' });
    } catch (err: any) {
      setEmailMessage({ type: 'error', text: err.message });
    } finally { setEmailSending(false); }
  };

  const generatePDF = (job: any) => window.open(`/api/jobs/${job.id}/pdf?token=${token}`, '_blank');
  const printJob = (job: any) => window.open(`/api/jobs/${job.id}/pdf?token=${token}`, '_blank');
  const viewJob = (job: any) => { setSelectedJob(job); setShowViewModal(true); };
  const editJob = (job: any) => {
    setEditingJob(job);
    setEditJobData({
      customer_name: job.customer_name || '',
      company_name: job.company_name || '',
      address: job.address || '',
      region: job.region || '',
      postcode: job.postcode || '',
      customer_type: job.customer_type || 'domestic',
      job_type: job.job_type || 'vehicle',
      vehicle_reg: job.vehicle_reg || '',
      service_type: job.service_type || '',
      quantity: job.quantity || 1,
      issue: job.issue || '',
      price: parseFloat(job.price) || 0,
      status: job.status || 'pending'
    });
    setShowJobEditModal(true);
  };

  const handleJobEditSave = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/jobs/' + editingJob.id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(editJobData)
      });
      if (res.ok) {
        setShowJobEditModal(false);
        loadData();
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  // Helper to get full image URL
  const getImageUrl = (url: string | null) => {
    if (!url) return null;
    if (!url) return null;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads')) return `https://locktrak.co.uk${url}`;
    return url;
  };

  // Filter jobs
  const filteredJobs = jobs.filter(job => {
    if (searchQuery) {
      return (job.job_number || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
             (job.customer_name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
             (job.vehicle_reg || '').toLowerCase().includes(searchQuery.toLowerCase());
    }
    if (dateFilter && job.created_at) {
      return new Date(job.created_at).toDateString() === new Date(dateFilter).toDateString();
    }
    return true;
  });

  // Update profile
  const updateProfile = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/api/auth/profile', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ first_name: profile.first_name, last_name: profile.last_name, phone: profile.phone })
      });
      if (res.ok) { setProfileMessage('Profile updated!'); setTimeout(() => setProfileMessage(''), 3000); }
      else setProfileError('Failed');
    } catch (err) { setProfileError('Error'); }
    finally { setLoading(false); }
  };

  const changePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (passwordData.new_password !== passwordData.confirm_password) { setProfileError('Passwords do not match'); return; }
    if (passwordData.new_password.length < 6) { setProfileError('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ current_password: passwordData.current_password, new_password: passwordData.new_password })
      });
      if (res.ok) { setProfileMessage('Password changed!'); setPasswordData({ current_password: '', new_password: '', confirm_password: '' }); }
      else setProfileError('Failed');
    } catch (err) { setProfileError('Error'); }
    finally { setLoading(false); }
  };

  const createCustomer = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/api/customers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({...newCustomer, address: [newCustomer.addr_line1, newCustomer.addr_line2, newCustomer.addr_city, newCustomer.addr_county].filter(Boolean).join('\n')})
      });
      if (res.ok) {
        alert('Customer added!');
        setShowCustomerForm(false);
        setNewCustomer({ first_name: '', surname: '', email: '', mobile_tel: '', company_name: '', company_tel: '', postcode: '', address: '', addr_line1: '', addr_line2: '', addr_city: '', addr_county: '' });
        loadData();
      }
    } catch (err) { alert('Error'); }
    finally { setLoading(false); }
  };

  const editCustomer = (customer: any) => {
    setEditingCustomer(customer);
    setShowCustomerEditModal(true);
  };

  const handleCustomerEditSave = (id: string, data: any) => {
    fetch("/api/customers/" + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      body: JSON.stringify(data)
    }).then(r => { if (r.ok) { setShowCustomerEditModal(false); loadData(); } });
  };

  const [gpsStatus, setGpsStatus] = useState('');
  const [gpsCoords, setGpsCoords] = useState<{lat: number, lng: number} | null>(null);
  const [lookupLoading, setLookupLoading] = useState(false);
  const [lookupMsg, setLookupMsg] = useState('');

  const captureGPS = () => {
    if (navigator.geolocation) {
      setGpsStatus('Acquiring GPS...');
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setGpsCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
          setGpsStatus('GPS: ' + pos.coords.latitude.toFixed(4) + ', ' + pos.coords.longitude.toFixed(4));
        },
        () => { setGpsStatus('GPS unavailable'); },
        { timeout: 10000, enableHighAccuracy: true }
      );
    } else {
      setGpsStatus('GPS not supported');
    }
  };

  const lookupVehicle = async () => {
    const reg = newJob.vehicle_reg;
    if (!reg || reg.length < 2) { setLookupMsg('Enter a registration first'); setTimeout(() => setLookupMsg(''), 3000); return; }
    setLookupLoading(true);
    setLookupMsg('Looking up ' + reg + '...');
    try {
      const res = await fetch('/api/vehicles/lookup-reg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ registration: reg })
      });
      const data = await res.json();
      if (data.found && data.data) {
        const v = data.data;
        setNewJob(prev => ({
          ...prev,
          vehicle_make: v.make || prev.vehicle_make,
          vehicle_model: v.model || v.make || prev.vehicle_model,
          vehicle_colour: v.colour || prev.vehicle_colour,
          vehicle_vin: ''
        }));
        setLookupMsg('Found: ' + (v.make || '') + ' ' + (v.model || '') + ' (' + (v.yearOfManufacture || '') + ')');
      } else {
        setLookupMsg('Not found: ' + (data.error || 'Unknown reg'));
      }
    } catch (err) {
      setLookupMsg('Lookup failed');
    }
    setLookupLoading(false);
    setTimeout(() => setLookupMsg(''), 4000);
  };

  const [customerSearchMsg, setCustomerSearchMsg] = useState('');

  const lookupCustomer = async (searchQuery: string) => {
    if (!searchQuery || searchQuery.length < 2) return;
    setCustomerSearchMsg('🔍 Searching...');
    try {
      const res = await fetch(`/api/customers/lookup?query=${encodeURIComponent(searchQuery)}`, {
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      if (data.found && data.customer) {
        const c = data.customer;
        setNewJob(prev => ({
          ...prev,
          customer_name: `${c.first_name || ''} ${c.surname || ''}`.trim(),
          customer_email: c.email || '',
          customer_phone: c.mobile_tel || '',
          company_name: c.company_name || '',
          address: c.address || '',
          postcode: c.postcode || '',
          customer_type: c.customer_type || 'domestic'
        }));
        setCustomerSearchMsg('✅ Found in local database');
        setTimeout(() => setCustomerSearchMsg(''), 3000);
      } else {
        setCustomerSearchMsg('🆕 New customer');
        setTimeout(() => setCustomerSearchMsg(''), 3000);
      }
    } catch (err) { setCustomerSearchMsg(''); }
  };

  const deleteCustomer = async (id: string) => {
    if (window.confirm("Delete this customer?")) {
      await fetch("/api/customers/" + id, { method: "DELETE", headers: { Authorization: "Bearer " + token } });
      loadData();
    }
  };

  const stepLabels = ['Details', 'Customer', 'Vehicle', 'V5C', 'ID', 'Sign', 'Review'];
  const totalSteps = stepLabels.length;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* Header */}
      <div style={{ background: '#1e3c72', color: 'white', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {companySettings.company_logo ? (
            <img src={companySettings.company_logo} alt="Logo" style={{ height: '36px', borderRadius: '4px' }} />
          ) : (
            <span style={{ fontSize: '24px' }}>🔐</span>
          )}
          <div>
            <div style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: 'bold' }}>{companySettings.company_name || 'LockTrak'} Technician</div>
            <div style={{ fontSize: '10px', opacity: 0.8 }}>Version 2.0</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 10px', borderRadius: '999px', background: isOnline ? 'rgba(16,185,129,0.18)' : 'rgba(148,163,184,0.25)', fontSize: '11px', fontWeight: '600' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: isOnline ? '#10b981' : '#94a3b8' }} />
            {isOnline ? 'Online' : 'Offline'}
          </span>
          <button onClick={() => { loadProfile(); setShowProfileModal(true); }} style={{ padding: '6px 12px', background: 'white', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: '#1e3c72', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}>👤 Profile</button>
          <button onClick={onLogout} style={{ padding: '6px 12px', background: '#e74c3c', border: 'none', borderRadius: '6px', color: 'white', cursor: 'pointer', fontSize: '14px' }}>Logout</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ background: 'white', borderBottom: '1px solid #ddd', padding: '0 8px', display: 'flex', gap: '8px', overflowX: 'auto' }}>
        {['dashboard', 'jobs', 'customers', 'services', 'subscription', 'knowledge', 'pdf_layout'].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{ padding: '10px 12px', whiteSpace: 'nowrap', background: 'none', border: 'none', cursor: 'pointer', fontWeight: activeTab === tab ? 'bold' : 'normal', borderBottom: activeTab === tab ? '2px solid #2a5298' : 'none', color: activeTab === tab ? '#2a5298' : '#666' }}>
            {tab === 'dashboard' && '📊 Dashboard'}
            {tab === 'jobs' && '📋 Jobs'}
            {tab === 'customers' && '👥 Customers'}
            {tab === 'services' && '🔧 Services'}
            {tab === 'subscription' && '💳 Subscription'}
            {tab === 'knowledge' && '📚 KB'}
            {tab === 'pdf_layout' && '📄 PDF Layout'}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div style={{ padding: '12px' }}>
        {/* Dashboard */}
        {activeTab === 'dashboard' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
              <h1 style={{ fontSize: '22px', margin: 0 }}>📊 Dashboard</h1>
              <button onClick={() => { setActiveTab('jobs'); setShowModal(true); }} style={{ padding: '10px 20px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>+ New Job</button>
            </div>

            {/* Stats Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: '12px', marginBottom: '24px' }}>
              <div onClick={() => setActiveTab('jobs')} style={{ background: 'white', padding: '20px', borderRadius: '12px', cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderLeft: '4px solid #2a5298' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#2a5298' }}>{dashboardStats.totalJobs}</div>
                <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>Total Jobs</div>
                <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>{dashboardStats.completedJobs} done • {dashboardStats.pendingJobs} pending • {dashboardStats.closedJobs} closed</div>
              </div>
              <div onClick={() => setActiveTab('jobs')} style={{ background: 'white', padding: '20px', borderRadius: '12px', cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderLeft: '4px solid #10b981' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#10b981' }}>£{dashboardStats.totalRevenue.toFixed(2)}</div>
                <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>Total Revenue</div>
                <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>£{dashboardStats.monthlyRevenue.toFixed(2)} this month</div>
              </div>
              <div onClick={() => setActiveTab('customers')} style={{ background: 'white', padding: '20px', borderRadius: '12px', cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderLeft: '4px solid #f59e0b' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#f59e0b' }}>{dashboardStats.totalCustomers}</div>
                <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>Customers</div>
              </div>
              <div onClick={() => setActiveTab('jobs')} style={{ background: 'white', padding: '20px', borderRadius: '12px', cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderLeft: '4px solid #8b5cf6' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#8b5cf6' }}>{dashboardStats.sermiJobs}</div>
                <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>SERMI Jobs</div>
                <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>{dashboardStats.totalJobs > 0 ? Math.round((dashboardStats.sermiJobs / dashboardStats.totalJobs) * 100) : 0}% of all jobs</div>
              </div>
            </div>

            {/* Recent Jobs */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '16px' }}>🕐 Recent Jobs</h3>
              {dashboardStats.recentJobs && dashboardStats.recentJobs.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {dashboardStats.recentJobs.map((job: any) => (
                    <div key={job.id} onClick={() => viewJob(job)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: '#f8fafc', borderRadius: '8px', cursor: 'pointer', flexWrap: 'wrap', gap: '8px' }}>
                      <div>
                        <strong>{job.job_number}</strong>
                        <span style={{ marginLeft: '8px', fontSize: '13px', color: '#666' }}>{job.customer_name}</span>
                      </div>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <span style={{ padding: '2px 8px', borderRadius: '12px', fontSize: '11px', background: job.status === 'completed' ? '#d1fae5' : '#fef3c7', color: job.status === 'completed' ? '#065f46' : '#92400e' }}>{job.status}</span>
                        <span style={{ fontWeight: 'bold', color: '#2a5298' }}>£{parseFloat(job.price || 0).toFixed(2)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ color: '#999', textAlign: 'center' }}>No jobs yet</p>
              )}
            </div>
          </div>
        )}

        {/* Jobs */}
        {activeTab === 'jobs' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
              <h1 style={{ fontSize: '20px', margin: 0 }}>Jobs</h1>
              <button onClick={() => setShowModal(true)} style={{ padding: '8px 16px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>+ New Job</button>
            </div>

            {/* Search */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <input type="text" placeholder="Search..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onKeyPress={e => e.key === 'Enter' && setSearchQuery(searchQuery)} style={{ flex: 1, padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '16px' }} />
              <input type="date" value={dateFilter} onChange={e => setDateFilter(e.target.value)} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
              <button onClick={() => { setSearchQuery(''); setDateFilter(''); }} style={{ padding: '10px 16px', background: '#e2e8f0', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Clear</button>
            </div>

            {/* Job Cards */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {filteredJobs.map(job => (
                <div key={job.id} style={{ background: 'white', borderRadius: '12px', padding: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' }}>
                    <div><strong>{job.job_number}</strong> {job.is_sermi && <span style={{ marginLeft: '8px', padding: '2px 8px', background: '#d1fae5', color: '#065f46', borderRadius: '12px', fontSize: '11px' }}>SERMI</span>}</div>
                    <span style={{ padding: '2px 8px', background: '#fef3c7', borderRadius: '12px', fontSize: '11px' }}>{job.status || 'pending'}</span>
                  </div>
                  <div style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
                    <div>👤 {job.customer_name}</div>
                    <div>🚗 {job.vehicle_reg}</div>
                    <div>💰 £{job.price}</div>
                  </div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', borderTop: '1px solid #eee', paddingTop: '10px' }}>
                    <button onClick={() => viewJob(job)} style={{ padding: '6px 10px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>View</button>
                    <button onClick={() => editJob(job)} style={{ padding: '6px 10px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Edit</button>
                    <button onClick={() => printJob(job)} style={{ padding: '6px 10px', background: '#64748b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Print</button>
                    <button onClick={() => generatePDF(job)} style={{ padding: '6px 10px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>PDF</button>
                    <button onClick={() => openEmailDialog(job)} style={{ padding: '6px 10px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Email</button>
                    {job.status === 'closed' ? (
                    <button onClick={() => reopenJob(job)} style={{ padding: '6px 10px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Reopen</button>
                  ) : job.status !== 'completed' && (
                    <button onClick={() => closeJob(job)} style={{ padding: '6px 10px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Close</button>
                  )}
                  <button onClick={() => deleteJob(job.id)} style={{ padding: '6px 10px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Delete</button>
                  </div>
                </div>
              ))}
              {filteredJobs.length === 0 && <div style={{ textAlign: 'center', padding: '40px', background: 'white', borderRadius: '12px' }}>No jobs found</div>}
            </div>
          </div>
        )}

        {/* Customers */}
        {activeTab === 'customers' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
              <h1 style={{ fontSize: '20px', margin: 0 }}>Customers</h1>
              <button onClick={() => setShowCustomerForm(!showCustomerForm)} style={{ padding: '8px 16px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>{showCustomerForm ? 'Cancel' : '+ Add'}</button>
            </div>
            {showCustomerForm && (
              <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
                <h3 style={{ fontSize: '16px', marginBottom: '12px' }}>New Customer</h3>
                <form onSubmit={createCustomer}>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="First Name" value={newCustomer.first_name} onChange={e => setNewCustomer({...newCustomer, first_name: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} required /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="Surname" value={newCustomer.surname} onChange={e => setNewCustomer({...newCustomer, surname: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} required /></div>
                  <div style={{ marginBottom: '10px' }}><input type="email" placeholder="Email" value={newCustomer.email} onChange={e => setNewCustomer({...newCustomer, email: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="tel" placeholder="Mobile" value={newCustomer.mobile_tel} onChange={e => setNewCustomer({...newCustomer, mobile_tel: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="Company Name" value={newCustomer.company_name} onChange={e => setNewCustomer({...newCustomer, company_name: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="tel" placeholder="Company Phone" value={newCustomer.company_tel} onChange={e => setNewCustomer({...newCustomer, company_tel: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="Address Line 1 (house & street)" value={newCustomer.addr_line1} onChange={e => setNewCustomer({...newCustomer, addr_line1: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="Address Line 2 (optional)" value={newCustomer.addr_line2} onChange={e => setNewCustomer({...newCustomer, addr_line2: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="Town / City" value={newCustomer.addr_city} onChange={e => setNewCustomer({...newCustomer, addr_city: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="County" value={newCustomer.addr_county} onChange={e => setNewCustomer({...newCustomer, addr_county: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <div style={{ marginBottom: '10px' }}><input type="text" placeholder="Postcode" value={newCustomer.postcode} onChange={e => setNewCustomer({...newCustomer, postcode: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} /></div>
                  <button type="submit" disabled={loading} style={{ width: '100%', padding: '10px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>{loading ? 'Adding...' : 'Add Customer'}</button>
                </form>
              </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {customers.map(c => (
                <div key={c.id} style={{ background: 'white', borderRadius: '12px', padding: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <strong>{c.first_name} {c.surname}</strong>
                      <div style={{ fontSize: '12px', color: '#666' }}>📧 {c.email || '-'} | 📱 {c.mobile_tel || '-'}</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>🏢 {c.company_name || '-'}</div>
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '4px', whiteSpace: 'pre-wrap' }}>📍 {c.address || '-'}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <button onClick={() => editCustomer(c)} style={{ padding: '4px 8px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>✏️</button>
                      <button onClick={() => deleteCustomer(c.id)} style={{ padding: '4px 8px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>🗑️</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Services */}
        {activeTab === 'services' && (
          <ServicesManager token={token} onServiceSelect={(s) => { setNewJob(prev => ({...prev, service_type: s.name, price: s.price})); setActiveTab('jobs'); setShowModal(true); }} />
        )}

        {activeTab === 'subscription' && (
          <SubscriptionTab token={token} />
        )}
      </div>

{activeTab === 'knowledge' && <KnowledgeBase token={token} />}
        {activeTab === 'pdf_layout' && (
          <PDFLayoutDesigner token={token} />
        )}
      {/* View Job Modal */}
      {showViewModal && selectedJob && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '500px', maxHeight: '80vh', overflow: 'auto', padding: '20px' }}>
            <h2 style={{ fontSize: '18px' }}>Job #{selectedJob.job_number}</h2>
            <div style={{ marginTop: '12px' }}>
              <p><strong>Customer:</strong> {selectedJob.customer_name}</p>
              <p><strong>Vehicle:</strong> {selectedJob.vehicle_reg}</p>
              <p><strong>Issue:</strong> {selectedJob.issue}</p>
              <p><strong>Price:</strong> £{selectedJob.price}</p>
              {selectedJob.is_sermi && (
                <div>
                  <h3 style={{ fontSize: '16px', marginTop: '12px', borderBottom: '1px solid #eee', paddingBottom: '4px' }}>SERMI Evidence</h3>
                  
                  {selectedJob.v5c_image_url && (
                    <div style={{ marginBottom: '16px' }}>
                      <strong style={{ fontSize: '14px' }}>📄 V5C Document:</strong>
                      <div style={{ marginTop: '8px' }}>
                        <img 
                          src={getImageUrl(selectedJob.v5c_image_url) || ""} 
                          alt="V5C Document" 
                          style={{ width: '100%', maxHeight: '250px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd', background: '#f9f9f9' }}
                          onError={(e) => { (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 24 24" fill="none" stroke="%23999" stroke-width="2"%3E%3Crect x="2" y="2" width="20" height="20" rx="2.18"%3E%3C/rect%3E%3Cpath d="M8 2v20M16 2v20"%3E%3C/path%3E%3C/svg%3E' }}
                        />
                      </div>
                    </div>
                  )}
                  
                  {selectedJob.photo_id_image_url && (
                    <div style={{ marginBottom: '16px' }}>
                      <strong style={{ fontSize: '14px' }}>🪪 Photo ID ({selectedJob.photo_id_type || 'ID'}):</strong>
                      <div style={{ marginTop: '8px' }}>
                        <img 
                          src={getImageUrl(selectedJob.photo_id_image_url) || ""} 
                          alt="Photo Identification" 
                          style={{ width: '100%', maxHeight: '250px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd', background: '#f9f9f9' }}
                          onError={(e) => { (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 24 24" fill="none" stroke="%23999" stroke-width="2"%3E%3Crect x="2" y="2" width="20" height="20" rx="2.18"%3E%3C/rect%3E%3Cpath d="M8 2v20M16 2v20"%3E%3C/path%3E%3C/svg%3E' }}
                        />
                      </div>
                      {selectedJob.photo_id_number && <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>Document No: {selectedJob.photo_id_number}</div>}
                    </div>
                  )}
                  
                  {selectedJob.signature_url && (
                    <div style={{ marginBottom: '16px' }}>
                      <strong style={{ fontSize: '14px' }}>✍️ Signature:</strong>
                      <div style={{ marginTop: '8px' }}>
                        <img 
                          src={getImageUrl(selectedJob.signature_url) || ""} 
                          alt="Signature" 
                          style={{ width: '100%', maxHeight: '120px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd', background: 'white' }}
                        />
                      </div>
                      {selectedJob.signature_name && <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>Signed by: {selectedJob.signature_name}</div>}
                      {selectedJob.signature_date && <div style={{ fontSize: '12px', color: '#666' }}>Date: {new Date(selectedJob.signature_date).toLocaleDateString()}</div>}
                    </div>
                  )}
                  
                  {!selectedJob.v5c_image_url && !selectedJob.photo_id_image_url && !selectedJob.signature_url && (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>No SERMI evidence uploaded</div>
                  )}
                </div>
              )}
            </div>
            {/* Job Address & Vehicle Details */}
              {selectedJob.address && <p><strong>Address:</strong><br/>{selectedJob.address.split('\n').map((l: string, i: number) => <span key={i}>{l}<br/></span>)}</p>}
              {selectedJob.vehicle_vin && <p><strong>VIN:</strong> {selectedJob.vehicle_vin}</p>}
              {selectedJob.vehicle_make && <p><strong>Make:</strong> {selectedJob.vehicle_make}</p>}
              {selectedJob.vehicle_model && <p><strong>Model:</strong> {selectedJob.vehicle_model}</p>}
              {selectedJob.vehicle_colour && <p><strong>Colour:</strong> {selectedJob.vehicle_colour}</p>}
              
              {/* GPS Location */}
              {selectedJob.gps_lat && selectedJob.gps_lng && (
                <div style={{ marginTop: '12px', marginBottom: '16px' }}>
                  <strong style={{ fontSize: '14px' }}>📍 GPS Location:</strong>
                  <p style={{ fontSize: '12px', color: '#666', margin: '4px 0' }}>
                    {parseFloat(selectedJob.gps_lat).toFixed(6)}, {parseFloat(selectedJob.gps_lng).toFixed(6)}
                  </p>
                  <a href={'https://maps.google.com/maps?q=' + selectedJob.gps_lat + ',' + selectedJob.gps_lng} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', color: '#1d4ed8' }}>Open in Google Maps {'↗'}</a>
                </div>
              )}
              
              {/* Technician Signature */}
              {selectedJob.is_sermi && selectedJob.technician_signature && (
                <div style={{ marginBottom: '16px' }}>
                  <strong style={{ fontSize: '14px' }}>🔧 Technician Signature:</strong>
                  <div style={{ marginTop: '8px' }}>
                    <img src={selectedJob.technician_signature} alt="Technician Signature" style={{ width: '100%', maxHeight: '80px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd', background: 'white' }} />
                  </div>
                  {selectedJob.technician_name && <div style={{ marginTop: '4px', fontSize: '12px', color: '#666' }}>Verified by: {selectedJob.technician_name}</div>}
                  {selectedJob.technician_signed_at && <div style={{ fontSize: '12px', color: '#666' }}>Date: {new Date(selectedJob.technician_signed_at).toLocaleDateString()}</div>}
                </div>
              )}

              {/* Extra Photos */}
              {selectedJob.extra_photos && (() => {
                try {
                  const photos = typeof selectedJob.extra_photos === 'string' ? JSON.parse(selectedJob.extra_photos) : selectedJob.extra_photos;
                  if (Array.isArray(photos) && photos.length > 0) {
                    return (
                      <div style={{ marginBottom: '16px' }}>
                        <strong style={{ fontSize: '14px' }}>📎 Extra Photos:</strong>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginTop: '8px' }}>
                          {photos.map((url: string, i: number) => (
                            <img key={i} src={getImageUrl(url) || url} alt={"Extra " + i} style={{ width: '100%', maxHeight: '150px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd', background: '#f9f9f9' }} />
                          ))}
                        </div>
                      </div>
                    );
                  }
                } catch(e) {}
                return null;
              })()}

              {selectedJob.is_sermi && (
                <div style={{ marginTop: '16px', padding: '12px', background: selectedJob.locked_at ? '#fef2f2' : '#f0fdf4', borderRadius: '8px', border: selectedJob.locked_at ? '1px solid #fecaca' : '1px solid #bbf7d0' }}>
                  {selectedJob.locked_at ? (
                    <div>
                      <div style={{ fontSize: '13px', color: '#991b1b', fontWeight: '600', marginBottom: '8px' }}>🔒 Record locked at {new Date(selectedJob.locked_at).toLocaleString('en-GB')}</div>
                      <button onClick={() => unlockJob(selectedJob)} style={{ width: '100%', padding: '10px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>🔓 Unlock (requires reason)</button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: '13px', color: '#065f46', fontWeight: '600', marginBottom: '8px' }}>Compliance record not yet locked</div>
                      <button onClick={() => lockJob(selectedJob)} style={{ width: '100%', padding: '10px', background: '#059669', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>🔒 Lock Compliance Record</button>
                    </div>
                  )}
                </div>
              )}
            <button onClick={() => setShowViewModal(false)} style={{ marginTop: '20px', width: '100%', padding: '12px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Close</button>
          </div>
        </div>
      )}

      {/* NEW JOB MODAL */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '550px', maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h3 style={{ fontSize: '18px', margin: 0 }}>New Job</h3>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>&times;</button>
            </div>
            <form onSubmit={createJob} style={{ padding: '16px' }}>
              <StepProgress currentStep={currentStep} totalSteps={6} stepLabels={['Type', 'Customer', 'Vehicle', 'Documents', 'Signatures', 'Review']} onStepClick={(s) => { if (s < currentStep) setCurrentStep(s); }} />

              {currentStep === 1 && (<>
              <div style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #eee' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <input type="checkbox" checked={newJob.is_sermi} onChange={e => setNewJob({...newJob, is_sermi: e.target.checked})} />
                  <span style={{ fontSize: '14px' }}>This job requires SERMI compliance (ID verification, V5C, signature)</span>
                </label>
              </div>
              {newJob.is_sermi && (
                <div style={{ marginTop: '16px', padding: '16px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <h4 style={{ color: '#1a3a5c', margin: '0 0 8px 0', fontSize: '14px' }}>🔎 Job Source</h4>
                  <div style={{ marginBottom: '14px' }}>
                    <select value={jobSource} onChange={e => setJobSource(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}>
                      <option value="private_customer">Private customer (vehicle presented by owner/keeper)</option>
                      <option value="fleet_rental_loan">Fleet / rental / loan vehicle</option>
                      <option value="remote_mobile">Remote / mobile (roadside locksmith)</option>
                      <option value="work_provider">Work provider (insurance / warranty / broker)</option>
                      <option value="subcontractor">Sub-contractor (working for another locksmith/garage)</option>
                    </select>
                  </div>
                  {(jobSource === 'fleet_rental_loan' || jobSource === 'work_provider' || jobSource === 'subcontractor') && (
                    <div style={{ marginBottom: '14px', padding: '12px', background: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px', color: '#1a3a5c' }}>🏢 {jobSource === 'fleet_rental_loan' ? 'Fleet / Rental Company' : jobSource === 'work_provider' ? 'Work Provider' : 'Contractor'} Details</div>
                      <input type="text" placeholder="Company name" value={authorityCompanyName} onChange={e => setAuthorityCompanyName(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '8px' }} />
                      <input type="text" placeholder="Contact name" value={authorityContactName} onChange={e => setAuthorityContactName(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '8px' }} />
                      <input type="email" placeholder="Contact email" value={authorityContactEmail} onChange={e => setAuthorityContactEmail(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '8px' }} />
                      <input type="text" placeholder="Company address" value={authorityCompanyAddress} onChange={e => setAuthorityCompanyAddress(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '8px' }} />
                      <input type="tel" placeholder="Company phone" value={authorityCompanyPhone} onChange={e => setAuthorityCompanyPhone(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '8px' }} />
                      <div style={{ fontSize: '12px', fontWeight: '600', margin: '6px 0', color: '#1a3a5c' }}>Driver ID (person who brought the vehicle)</div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                        <select value={driverIdType} onChange={e => setDriverIdType(e.target.value)} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}><option value="">ID type</option><option value="company_id">Company ID</option><option value="passport">Passport</option><option value="driving_licence">Driving licence</option></select>
                        <input type="text" placeholder="ID reference" value={driverIdReference} onChange={e => setDriverIdReference(e.target.value)} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
                      </div>
                    </div>
                  )}
                </div>
              )}
              </>)}

              {currentStep === 2 && (<>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>First Name *</label><input type="text" value={newJob.customer_name?.split(' ')[0] || ''} onChange={e => setNewJob({...newJob, customer_name: e.target.value + ' ' + (newJob.customer_name?.split(' ').slice(1).join(' ') || '')})} onBlur={() => lookupCustomer(newJob.customer_name || '')} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} required /></div>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>Surname *</label><input type="text" value={newJob.customer_name?.split(' ').slice(1).join(' ') || ''} onChange={e => setNewJob({...newJob, customer_name: (newJob.customer_name?.split(' ')[0] || '') + ' ' + e.target.value})} onBlur={() => lookupCustomer(newJob.customer_name || '')} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} required /></div>
              </div>
              <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Company Name</label><input type="text" value={newJob.company_name} onChange={e => setNewJob({...newJob, company_name: e.target.value})} onBlur={() => lookupCustomer(newJob.company_name || newJob.customer_name || '')} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
              {customerSearchMsg && <div style={{ marginBottom: '10px', padding: '6px 10px', background: customerSearchMsg.includes('✅') ? '#d1fae5' : customerSearchMsg.includes('🔄') ? '#dbeafe' : customerSearchMsg.includes('🆕') ? '#fef3c7' : '#e2e8f0', borderRadius: '6px', fontSize: '12px', color: '#334155' }}>{customerSearchMsg}</div>}
              {newJob.is_sermi ? (
                <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Address (V5C keeper address)</label><textarea rows={5} value={newJob.address} onChange={e => setNewJob({...newJob, address: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: '\"Courier New\", monospace', resize: 'vertical', whiteSpace: 'pre-wrap' }} /></div>
              ) : (
                <div>
                  <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Address Line 1</label><input type="text" value={newJob.addr_line1} onChange={e => setNewJob({...newJob, addr_line1: e.target.value, address: [e.target.value, newJob.addr_line2, newJob.addr_city, newJob.addr_county].filter(Boolean).join('\n')})} placeholder="House number and street" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: '\"Courier New\", monospace' }} /></div>
                  <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Address Line 2</label><input type="text" value={newJob.addr_line2} onChange={e => setNewJob({...newJob, addr_line2: e.target.value, address: [newJob.addr_line1, e.target.value, newJob.addr_city, newJob.addr_county].filter(Boolean).join('\n')})} placeholder="Area (optional)" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: '\"Courier New\", monospace' }} /></div>
                  <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Town / City</label><input type="text" value={newJob.addr_city} onChange={e => setNewJob({...newJob, addr_city: e.target.value, address: [newJob.addr_line1, newJob.addr_line2, e.target.value, newJob.addr_county].filter(Boolean).join('\n')})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: '\"Courier New\", monospace' }} /></div>
                  <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>County</label><input type="text" value={newJob.addr_county} onChange={e => setNewJob({...newJob, addr_county: e.target.value, address: [newJob.addr_line1, newJob.addr_line2, newJob.addr_city, e.target.value].filter(Boolean).join('\n')})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: '\"Courier New\", monospace' }} /></div>
                  <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Postcode</label><input type="text" value={newJob.postcode} onChange={e => setNewJob({...newJob, postcode: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: '\"Courier New\", monospace' }} /></div>
                </div>
              )}
              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: '500' }}>Type</label>
                <select value={newJob.customer_type} onChange={e => setNewJob({...newJob, customer_type: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}>
                  <option value="domestic">Domestic</option>
                  <option value="commercial">Commercial</option>
                </select>
              </div>
              <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Email</label><input type="email" value={newJob.customer_email} onChange={e => setNewJob({...newJob, customer_email: e.target.value})} placeholder="customer@example.com" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
              <div style={{ marginBottom: '10px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Phone</label><input type="tel" value={newJob.customer_phone} onChange={e => setNewJob({...newJob, customer_phone: e.target.value})} placeholder="07700 000000" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
              <div style={{ marginBottom: '10px', fontSize: '12px', color: '#64748b', display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span>{gpsStatus || '📍 No location captured'}</span>
                <button type="button" onClick={captureGPS} style={{ padding: '4px 10px', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' }}>Capture</button>
              </div>
              </>)}

              {currentStep === 3 && (<>
              <div style={{ marginBottom: '8px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Vehicle Registration *</label><div style={{ display: 'flex', gap: '8px' }}><input type="text" value={newJob.vehicle_reg} onChange={e => setNewJob({...newJob, vehicle_reg: e.target.value.toUpperCase()})} style={{ flex: 1, padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} required /><button type="button" onClick={lookupVehicle} disabled={lookupLoading} style={{ padding: '10px 14px', background: lookupLoading ? '#e2e8f0' : '#1e3c72', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap' }}>{lookupLoading ? '...' : 'Lookup'}</button></div>{lookupMsg && <div style={{ fontSize: '11px', color: lookupMsg.includes('Found') ? '#059669' : '#d97706', marginTop: '4px' }}>{lookupMsg}</div>}</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>Make</label><input type="text" value={newJob.vehicle_make} onChange={e => setNewJob({...newJob, vehicle_make: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>Model</label><input type="text" value={newJob.vehicle_model} onChange={e => setNewJob({...newJob, vehicle_model: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>Colour</label><input type="text" value={newJob.vehicle_colour || ''} onChange={e => setNewJob({...newJob, vehicle_colour: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ fontSize: '13px', fontWeight: '500' }}>VIN <span style={{ fontWeight: 'normal', color: '#94a3b8' }}>(auto-extracted from V5C photo)</span></label>
                <input type="text" value={newJob.vehicle_vin || ''} onChange={e => setNewJob({...newJob, vehicle_vin: e.target.value.toUpperCase()})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>Mileage at intake</label><input type="number" value={mileage} onChange={e => setMileage(e.target.value)} placeholder="e.g. 45000" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
                <div><label style={{ fontSize: '13px', fontWeight: '500' }}>VIN location</label><select value={vinLocation} onChange={e => setVinLocation(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}><option value="">-- Select --</option><option value="dashboard">Dashboard (windscreen)</option><option value="door_plate">Door plate / pillar</option><option value="engine_bay">Engine bay</option><option value="other">Other</option></select></div>
              </div>
              <div style={{ marginBottom: '12px', padding: '10px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <label style={{ fontSize: '13px', fontWeight: '500', display: 'block', marginBottom: '6px' }}>VIN verification — does the VIN on the vehicle match the V5C registration document?</label>
                <div style={{ display: 'flex', gap: '16px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}><input type="radio" name="vinMatch" checked={vinMatchesV5c === true} onChange={() => setVinMatchesV5c(true)} /><span style={{ fontSize: '13px' }}>Yes — matches</span></label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}><input type="radio" name="vinMatch" checked={vinMatchesV5c === false} onChange={() => setVinMatchesV5c(false)} /><span style={{ fontSize: '13px' }}>No — does not match</span></label>
                </div>
              </div>
              </>)}

              {currentStep === 4 && (<>
              {newJob.is_sermi ? (
                <div style={{ padding: '16px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <h4 style={{ color: '#1a3a5c', margin: '0 0 4px 0', fontSize: '14px' }}>🔒 Scan Documents</h4>
                  <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '12px' }}>
                    Scan the V5C and driving licence — LockTrak will auto-fill the job fields. Personal data is redacted before upload.
                  </p>
                  {showV5CRedactor && (
                <div style={{ marginBottom: '12px' }}>
                  <V5CRedactor
                    token={token}
                    documentType="v5c"
                    onRedacted={handleRedactedV5C}
                    onCancel={() => setShowV5CRedactor(false)}
                    onFieldsReady={(fields) => {
                      try { sessionStorage.setItem('locktrak_v5c_fields', JSON.stringify(fields)); } catch(e) {}
                      const updates: any = {};
                      if (fields.vin) updates.vehicle_vin = fields.vin;
                      if (fields.reg) updates.vehicle_reg = fields.reg;
                      if (fields.make) updates.vehicle_make = fields.make;
                      if (fields.model) updates.vehicle_model = fields.model;
                      if (fields.colour) updates.vehicle_colour = fields.colour;
                      if (fields.keeper_name) updates.customer_name = fields.keeper_name;
                      if (fields.keeper_address) updates.address = fields.keeper_address;
                      if (Object.keys(updates).length > 0) {
                        setNewJob(prev => ({...prev, ...updates}));

                      }
                    }}
                  />
                </div>
              )}
                  {showPhotoIdRedactor && (
                <div style={{ marginBottom: '12px' }}>
                  <V5CRedactor
                    token={token}
                    documentType="driving_licence"
                    onRedacted={handleRedactedPhotoId}
                    onCancel={() => setShowPhotoIdRedactor(false)}
                    onFieldsReady={(fields: any) => {
                      try { sessionStorage.setItem('locktrak_dl_fields', JSON.stringify(fields)); } catch(e) {}
                      const updates: any = {};
                      if (fields.surname || fields.given_names) {
                        updates.customer_name = ((fields.given_names || '') + ' ' + (fields.surname || '')).trim();
                      }
                      if (fields.document_number) setPhotoIdNumber(fields.document_number);
                      if (Object.keys(updates).length > 0) setNewJob(prev => ({...prev, ...updates}));
                    }}
                  />
                </div>
              )}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                    <button type="button" onClick={() => setShowV5CRedactor(true)} style={{ padding: '14px', background: v5cImage ? 'linear-gradient(135deg, #065f46, #059669)' : 'linear-gradient(135deg, #1e40af, #3b82f6)', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                      {v5cUploading ? '⏳ Uploading...' : v5cImage ? '✅ V5C Scanned' : '📄 Scan V5C'}
                    </button>
                    <button type="button" onClick={() => setShowPhotoIdRedactor(true)} style={{ padding: '14px', background: photoIdImage ? 'linear-gradient(135deg, #065f46, #059669)' : 'linear-gradient(135deg, #1e40af, #3b82f6)', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                      {photoIdImage ? '✅ ID Scanned' : '🪪 Scan Driving Licence'}
                    </button>
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <select value={photoIdType} onChange={e => setPhotoIdType(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', marginBottom: '8px', fontSize: '14px' }}>
                      <option value="driving_licence">Driving Licence</option>
                      <option value="passport">Passport</option>
                      <option value="national_id">National ID Card</option>
                    </select>
                    <input type="text" placeholder="ID Document Number" value={photoIdNumber} onChange={e => setPhotoIdNumber(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
                    <input type="text" placeholder="Name on ID" value={idName} onChange={e => setIdName(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginTop: '8px' }} />
                    <input type="text" placeholder="Verified by (your name)" value={idVerifiedBy} onChange={e => setIdVerifiedBy(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginTop: '8px' }} />
                  </div>
                  <div style={{ marginBottom: '12px' }}>
                    <label style={{ fontSize: '13px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' }}>📎 Additional Photos (optional)</label>
                    {extraPhotos.map((url, i) => (
                      <div key={i} style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src={url} alt="Extra" style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd' }} />
                        <button type="button" onClick={() => { setExtraPhotos(extraPhotos.filter((_,j) => j!==i)); setExtraPhotoFiles(extraPhotoFiles.filter((_,j) => j!==i)); }} style={{ padding: '4px 8px', background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>✕</button>
                      </div>
                    ))}
                    <button type="button" onClick={() => captureImage('extra')} style={{ width: '100%', padding: '10px', marginTop: '8px', background: '#f0f4f8', border: '2px dashed #94a3b8', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>
                      + Add Photo
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ padding: '20px', textAlign: 'center', background: '#f0f4f8', borderRadius: '8px' }}>SERMI not required for this job.</div>
              )}
              </>)}

              {currentStep === 5 && (<>
              <div style={{ marginBottom: '16px', padding: '14px', border: '2px solid #10b981', borderRadius: '12px', background: '#f0fdf4' }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#065f46', fontWeight: 'bold' }}>🟢 Customer Signature</h4>
                <input type="text" value={signatureName} onChange={e => setSignatureName(e.target.value)} placeholder="Print customer name" style={{ width: '100%', padding: '10px', border: '1px solid #10b981', borderRadius: '8px', fontSize: '14px', marginBottom: '8px', fontFamily: '\"Courier New\", monospace', boxSizing: 'border-box' }} />
                <div style={{ fontSize: '12px', color: '#065f46', marginBottom: '6px', fontFamily: '\"Courier New\", monospace' }}>📅 {new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} — {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</div>
                <div style={{ border: '2px solid #10b981', borderRadius: '8px', overflow: 'hidden', background: 'white', touchAction: 'none' }}>
                  <canvas ref={signaturePadRef} style={{ width: '100%', height: '100px', display: 'block' }} onTouchStart={startDrawing} onTouchMove={draw} onTouchEnd={endDrawing} onMouseDown={startDrawing} onMouseMove={draw} onMouseUp={endDrawing} onMouseLeave={endDrawing} />
                </div>
                <button type="button" onClick={clearSignature} style={{ marginTop: '8px', padding: '5px 12px', background: '#d1fae5', border: '1px solid #10b981', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#065f46' }}>Clear</button>
                {signatureData && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#10b981' }}>✅ Signed</span>}
              </div>
              <div style={{ marginBottom: '16px', padding: '14px', border: '2px solid #ef4444', borderRadius: '12px', background: '#fef2f2' }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#991b1b', fontWeight: 'bold' }}>🔴 Technician Signature</h4>
                <input type="text" value={techSigName} onChange={e => setTechSigName(e.target.value)} placeholder="Print technician name" style={{ width: '100%', padding: '10px', border: '1px solid #ef4444', borderRadius: '8px', fontSize: '14px', marginBottom: '8px', fontFamily: '\"Courier New\", monospace', boxSizing: 'border-box' }} />
                <div style={{ fontSize: '12px', color: '#991b1b', marginBottom: '6px', fontFamily: '\"Courier New\", monospace' }}>📅 {new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} — {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</div>
                <div style={{ border: '2px solid #ef4444', borderRadius: '8px', overflow: 'hidden', background: 'white', touchAction: 'none' }}>
                  <canvas ref={techSignaturePadRef} style={{ width: '100%', height: '100px', display: 'block' }} onTouchStart={techStartDrawing} onTouchMove={techDraw} onTouchEnd={techEndDrawing} onMouseDown={techStartDrawing} onMouseMove={techDraw} onMouseUp={techEndDrawing} onMouseLeave={techEndDrawing} />
                </div>
                <button type="button" onClick={clearTechSignature} style={{ marginTop: '8px', padding: '5px 12px', background: '#fee2e2', border: '1px solid #ef4444', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#991b1b' }}>Clear</button>
                {techSignatureData && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#ef4444' }}>✅ Signed</span>}
              </div>
              </>)}

              {currentStep === 6 && (<>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ fontSize: '13px', fontWeight: '500' }}>Service</label>
                <select value={newJob.service_type} onChange={e => { const svc = managedServices.find(s => s.name === e.target.value); if (svc) { setNewJob({...newJob, service_type: svc.name, price: svc.price}); } else { setNewJob({...newJob, service_type: e.target.value}); } }} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}>
                  <option value="">-- Select Service --</option>
                  {managedServices.filter(s => s.active).map(s => (
                    <option key={s.id} value={s.name}>{s.name} {s.price > 0 ? ' - £' + parseFloat(s.price).toFixed(2) : ''}</option>
                  ))}
                  <option value="__other__">Other (type below)</option>
                </select>
                {newJob.service_type === '__other__' && (
                  <input type="text" value={newJob.issue} onChange={e => setNewJob({...newJob, issue: e.target.value})} placeholder="Type service description here..." style={{ width: '100%', padding: '10px', marginTop: '8px', border: '1px solid #1a3a5c', borderRadius: '8px', fontSize: '14px' }} />
                )}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: '500' }}>Qty / Hours</label>
                <input type="number" value={newJob.quantity} onChange={e => setNewJob({...newJob, quantity: parseInt(e.target.value) || 1})} min="1" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
              </div>
              <div style={{ marginBottom: '12px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Description *</label><textarea value={newJob.issue} onChange={e => setNewJob({...newJob, issue: e.target.value})} rows={2} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} required /></div>
              <div style={{ marginBottom: '12px' }}><label style={{ fontSize: '13px', fontWeight: '500' }}>Price (£)</label><input type="number" value={newJob.price === undefined ? '' : newJob.price} onChange={e => setNewJob({...newJob, price: e.target.value === '' ? undefined : parseFloat(e.target.value)})} placeholder="Enter amount" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} /></div>
              <div style={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', fontSize: '12px', color: '#334155' }}>
                <div><strong>Customer:</strong> {newJob.customer_name || '—'} · <strong>Vehicle:</strong> {newJob.vehicle_reg || '—'} {newJob.vehicle_make || ''}</div>
                <div style={{ marginTop: '4px' }}><strong>Source:</strong> {jobSource} · <strong>SERMI:</strong> {newJob.is_sermi ? 'Yes' : 'No'} · <strong>GPS:</strong> {gpsStatus || 'Not captured'}</div>
              </div>
              </>)}

              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #ddd' }}>
                {currentStep > 1 ? (
                  <button type="button" onClick={() => setCurrentStep(currentStep - 1)} style={{ padding: '12px 20px', background: '#e2e8f0', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>← Back</button>
                ) : <div />}
                {currentStep < 6 && (
                  <button type="button" onClick={() => setCurrentStep(currentStep + 1)} style={{ padding: '12px 24px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', marginLeft: 'auto' }}>Next →</button>
                )}
                {currentStep === 6 && (
                  <button type="submit" disabled={loading || v5cUploading || photoIdUploading} style={{ padding: '12px 24px', marginLeft: 'auto', background: '#059669', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', opacity: (loading || v5cUploading || photoIdUploading) ? 0.7 : 1 }}>
                    {loading || v5cUploading || photoIdUploading ? 'Processing...' : '🔒 Create Job'}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}


      {/* Profile Modal */}
      {showProfileModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '600px', maxHeight: '85vh', overflow: 'auto', padding: '24px' }}>
            <h3 style={{ fontSize: '18px' }}>Profile</h3>
            {profileMessage && <div style={{ background: '#d1fae5', color: '#065f46', padding: '8px', borderRadius: '8px', marginBottom: '12px', fontSize: '13px' }}>{profileMessage}</div>}
            {profileError && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px', borderRadius: '8px', marginBottom: '12px', fontSize: '13px' }}>{profileError}</div>}
            <form onSubmit={updateProfile}>
              <input type="text" placeholder="First Name" value={profile.first_name} onChange={e => setProfile({...profile, first_name: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px' }} />
              <input type="text" placeholder="Last Name" value={profile.last_name} onChange={e => setProfile({...profile, last_name: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px' }} />
              <input type="email" placeholder="Email" value={profile.email} disabled style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px', background: '#f3f4f6' }} />
              <input type="tel" placeholder="Phone" value={profile.phone} onChange={e => setProfile({...profile, phone: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px' }} />
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '10px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Update</button>
            </form>
            <hr style={{ margin: '16px 0' }} />
            <h4 style={{ fontSize: '14px' }}>Business Settings</h4>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>These details appear on your compliance PDFs.</div>
            <div style={{ marginBottom: '12px', background: '#f8f9fa', borderRadius: '8px', padding: '12px', border: '1px solid #e5e7eb' }}>
              <label style={{ fontSize: '13px', fontWeight: '500', display: 'block', marginBottom: '8px' }}>Company Logo</label>
              {companySettings.company_logo ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <img src={companySettings.company_logo} alt="Logo" style={{ maxHeight: '50px', borderRadius: '4px' }} />
                  <button type="button" onClick={async () => {
                    await fetch('/api/company/settings', {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
                      body: JSON.stringify({...companySettings, company_logo: ''}),
                    });
                    setCompanySettings({...companySettings, company_logo: ''});
                  }} style={{ padding: '4px 8px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>Remove</button>
                </div>
              ) : null}
              <input type="file" accept="image/png,image/jpeg" onChange={async (e) => {
                const file = e.target.files?.[0];
                if (!file) return;
                if (file.size > 2 * 1024 * 1024) { alert('Logo must be under 2MB'); return; }
                const formData = new FormData();
                formData.append('logo', file);
                const res = await fetch('/api/company/logo', {
                  method: 'POST',
                  headers: { Authorization: 'Bearer ' + token },
                  body: formData,
                });
                if (res.ok) {
                  const data = await res.json();
                  setCompanySettings({...companySettings, company_logo: data.url});
                  setProfileMessage('✅ Logo uploaded');
                  setTimeout(() => setProfileMessage(''), 3000);
                } else {
                  const err = await res.text();
                  alert('Upload failed: ' + err);
                }
              }} style={{ fontSize: '13px' }} />
              <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>PNG or JPEG, max 2MB. Shows on your compliance PDFs.</div>
            </div>
            <form onSubmit={async (e) => {
              e.preventDefault();
              try {
                const res = await fetch('/api/company/settings', {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
                  body: JSON.stringify(companySettings),
                });
                if (res.ok) {
                  setProfileMessage('Business settings saved');
                  setTimeout(() => setProfileMessage(''), 3000);
                }
              } catch (err) { console.error(err); }
            }}>
              <input type="text" placeholder="Company Name" value={companySettings.company_name} onChange={e => setCompanySettings({...companySettings, company_name: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
              <textarea placeholder="Company Address" value={companySettings.company_address} onChange={e => setCompanySettings({...companySettings, company_address: e.target.value})} rows={3} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', resize: 'vertical' }} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                <input type="tel" placeholder="Company Phone" value={companySettings.company_phone} onChange={e => setCompanySettings({...companySettings, company_phone: e.target.value})} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
                <input type="email" placeholder="Company Email" value={companySettings.company_email} onChange={e => setCompanySettings({...companySettings, company_email: e.target.value})} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                <input type="text" placeholder="VAT Number" value={companySettings.vat_number} onChange={e => setCompanySettings({...companySettings, vat_number: e.target.value})} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
                <input type="text" placeholder="Company Reg Number" value={companySettings.company_reg_number} onChange={e => setCompanySettings({...companySettings, company_reg_number: e.target.value})} style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }} />
              </div>
              <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: '500' }}>VAT Registered</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input type="checkbox" checked={companySettings.vat_registered} onChange={e => setCompanySettings({...companySettings, vat_registered: e.target.checked})} />
                  <span style={{ fontSize: '13px' }}>{companySettings.vat_registered ? 'Yes - VAT registered' : 'No'}</span>
                </label>
              </div>

              <button type="submit" style={{ width: '100%', padding: '10px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Save Business Settings</button>
            </form>
            <hr style={{ margin: '16px 0' }} />
            <form onSubmit={changePassword}>
              <h4 style={{ fontSize: '14px' }}>Change Password</h4>
              <input type="password" placeholder="Current Password" value={passwordData.current_password} onChange={e => setPasswordData({...passwordData, current_password: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px' }} required />
              <input type="password" placeholder="New Password (min 6 chars)" value={passwordData.new_password} onChange={e => setPasswordData({...passwordData, new_password: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px' }} required />
              <input type="password" placeholder="Confirm Password" value={passwordData.confirm_password} onChange={e => setPasswordData({...passwordData, confirm_password: e.target.value})} style={{ width: '100%', padding: '10px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '8px' }} required />
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '10px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Change</button>
            </form>
            <button onClick={() => setShowProfileModal(false)} style={{ marginTop: '16px', width: '100%', padding: '10px', background: '#e2e8f0', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Close</button>
          </div>
        </div>
      )}

      {/* Email Dialog */}
      {showCustomerEditModal && editingCustomer && (
        <CustomerEditModal
          customer={editingCustomer}
          onSave={handleCustomerEditSave}
          onCancel={() => setShowCustomerEditModal(false)}
          token={token}
        />
      )}

      {showJobEditModal && editingJob && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '450px', maxHeight: '85vh', overflow: 'auto', padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
              <h3 style={{ margin: 0, fontSize: '18px' }}>✏️ Edit Job #{editingJob.job_number}</h3>
              <button onClick={() => setShowJobEditModal(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Customer Name</label><input value={editJobData.customer_name} onChange={e => setEditJobData({...editJobData, customer_name: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Company</label><input value={editJobData.company_name || ''} onChange={e => setEditJobData({...editJobData, company_name: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Address</label><input value={editJobData.address || ''} onChange={e => setEditJobData({...editJobData, address: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
              <div><label style={{ fontWeight: '500', fontSize: '13px' }}>Region</label><input value={editJobData.region || ''} onChange={e => setEditJobData({...editJobData, region: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
              <div><label style={{ fontWeight: '500', fontSize: '13px' }}>Postcode</label><input value={editJobData.postcode || ''} onChange={e => setEditJobData({...editJobData, postcode: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            </div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Type</label><select value={editJobData.customer_type || 'domestic'} onChange={e => setEditJobData({...editJobData, customer_type: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }}><option value="domestic">Domestic</option><option value="commercial">Commercial</option></select></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Vehicle Reg</label><input value={editJobData.vehicle_reg} onChange={e => setEditJobData({...editJobData, vehicle_reg: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Service</label><select value={editJobData.service_type || ''} onChange={e => { const svc = managedServices.find(s => s.name === e.target.value); setEditJobData({...editJobData, service_type: e.target.value, price: svc ? svc.price : editJobData.price}); }} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }}><option value="">-- Select --</option>{managedServices.filter(s => s.active).map(s => (<option key={s.id} value={s.name}>{s.name}</option>))}<option value="other">Other</option></select></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Qty</label><input type="number" value={editJobData.quantity || 1} onChange={e => setEditJobData({...editJobData, quantity: parseInt(e.target.value) || 1})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Issue</label><textarea value={editJobData.issue} onChange={e => setEditJobData({...editJobData, issue: e.target.value})} rows={2} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Price (£)</label><input type="number" value={editJobData.price} onChange={e => setEditJobData({...editJobData, price: parseFloat(e.target.value) || 0})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }} /></div>
            <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: '500', fontSize: '13px' }}>Status</label><select value={editJobData.status} onChange={e => setEditJobData({...editJobData, status: e.target.value})} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }}><option value="pending">Pending</option><option value="in_progress">In Progress</option><option value="completed">Completed</option><option value="closed">Closed</option></select></div>
            {/* Photo Management */}
            {editingJob && (editingJob.v5c_image_url || editingJob.photo_id_image_url) && (
              <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #eee' }}>
                <label style={{ fontWeight: '500', fontSize: '13px' }}>📸 Current Photos (click to remove)</label>
                <div style={{ display: 'flex', gap: '10px', marginTop: '8px', flexWrap: 'wrap' }}>
                  {editingJob.v5c_image_url && (
                    <div style={{ position: 'relative' }}>
                      <img src={editingJob.v5c_image_url.startsWith('http') ? editingJob.v5c_image_url : 'https://locktrak.co.uk' + editingJob.v5c_image_url} alt="V5C" style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd' }} />
                      <button onClick={async () => {
                        if (!window.confirm('Delete V5C photo?')) return;
                        await fetch(`/api/jobs/${editingJob.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify({ v5c_image_url: null }) });
                        setShowJobEditModal(false);
                        loadData();
                      }} style={{ position: 'absolute', top: '-6px', right: '-6px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '10px' }}>✕</button>
                    </div>
                  )}
                  {editingJob.photo_id_image_url && (
                    <div style={{ position: 'relative' }}>
                      <img src={editingJob.photo_id_image_url.startsWith('http') ? editingJob.photo_id_image_url : 'https://locktrak.co.uk' + editingJob.photo_id_image_url} alt="Photo ID" style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd' }} />
                      <button onClick={async () => {
                        if (!window.confirm('Delete Photo ID?')) return;
                        await fetch(`/api/jobs/${editingJob.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify({ photo_id_image_url: null }) });
                        setShowJobEditModal(false);
                        loadData();
                      }} style={{ position: 'absolute', top: '-6px', right: '-6px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '10px' }}>✕</button>
                    </div>
                  )}
                </div>
                <div style={{ marginTop: '10px', display: 'flex', gap: '8px' }}>
                  <button type="button" onClick={() => {
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.setAttribute('capture', 'environment');
                    input.onchange = async (e: any) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      const fd = new FormData();
                      fd.append('image', file);
                      const res = await fetch('/api/upload/v5c', { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: fd });
                      if (res.ok) {
                        const data = await res.json();
                        await fetch(`/api/jobs/${editingJob.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify({ v5c_image_url: data.url }) });
                        setShowJobEditModal(false);
                        loadData();
                      }
                    };
                    input.click();
                  }} style={{ padding: '6px 10px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' }}>📸 New V5C</button>
                  <button type="button" onClick={() => {
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.setAttribute('capture', 'environment');
                    input.onchange = async (e: any) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      const fd = new FormData();
                      fd.append('image', file);
                      const res = await fetch('/api/upload/photoid', { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: fd });
                      if (res.ok) {
                        const data = await res.json();
                        await fetch(`/api/jobs/${editingJob.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify({ photo_id_image_url: data.url }) });
                        setShowJobEditModal(false);
                        loadData();
                      }
                    };
                    input.click();
                  }} style={{ padding: '6px 10px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' }}>📸 New Photo ID</button>
                </div>
              </div>
            )}
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setShowJobEditModal(false)} style={{ flex: 1, padding: '10px', background: '#e2e8f0', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={handleJobEditSave} disabled={loading} style={{ flex: 1, padding: '10px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>{loading ? 'Saving...' : 'Save Changes'}</button>
            </div>
          </div>
        </div>
      )}

      {showEmailDialog && currentEmailJob && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '400px', padding: '20px' }}>
            <h3 style={{ fontSize: '18px', marginBottom: '12px' }}>Send Report</h3>
            <p style={{ fontSize: '14px', marginBottom: '12px' }}>Email for job #{currentEmailJob.job_number}:</p>
            <input type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} placeholder="customer@example.com" style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '16px', fontSize: '16px' }} autoFocus />
            {emailMessage && <div style={{ padding: '8px', borderRadius: '8px', marginBottom: '12px', background: emailMessage.type === 'success' ? '#d1fae5' : '#fee2e2', color: emailMessage.type === 'success' ? '#065f46' : '#991b1b', fontSize: '13px' }}>{emailMessage.text}</div>}
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button onClick={() => { setShowEmailDialog(false); setEmailMessage(null); }} style={{ padding: '8px 16px', background: '#e2e8f0', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={sendEmail} disabled={emailSending} style={{ padding: '8px 16px', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', cursor: emailSending ? 'not-allowed' : 'pointer' }}>{emailSending ? 'Sending...' : 'Send'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const PDFLayoutDesigner: React.FC<{ token: string }> = ({ token }) => {
  const [fields, setFields] = useState([
      { key: 'job_number', label: 'Job Number', enabled: true, order: 0 },
      { key: 'customer_name', label: 'Customer Name', enabled: true, order: 1 },
      { key: 'company_name', label: 'Company', enabled: true, order: 2 },
      { key: 'address', label: 'Address', enabled: false, order: 3 },
      { key: 'region', label: 'Region', enabled: false, order: 4 },
      { key: 'postcode', label: 'Postcode', enabled: true, order: 5 },
      { key: 'customer_type', label: 'Type', enabled: true, order: 6 },
      { key: 'customer_email', label: 'Email', enabled: false, order: 7 },
      { key: 'customer_phone', label: 'Phone', enabled: false, order: 8 },
      { key: 'vehicle_reg', label: 'Vehicle Reg', enabled: true, order: 9 },
      { key: 'vehicle_make', label: 'Make', enabled: false, order: 10 },
      { key: 'vehicle_model', label: 'Model', enabled: false, order: 11 },
      { key: 'vehicle_vin', label: 'VIN', enabled: false, order: 12 },
      { key: 'vehicle_colour', label: 'Colour', enabled: false, order: 13 },
      { key: 'service_type', label: 'Service', enabled: true, order: 14 },
      { key: 'quantity', label: 'Qty', enabled: false, order: 15 },
      { key: 'issue', label: 'Description', enabled: true, order: 16 },
      { key: 'price', label: 'Price', enabled: true, order: 17 },
      { key: 'status', label: 'Status', enabled: true, order: 18 },
      { key: 'created_at', label: 'Date', enabled: true, order: 19 },
      { key: 'gps_lat', label: 'GPS Coords', enabled: true, order: 20 },
      { key: 'v5c_image_url', label: 'V5C Image', enabled: true, order: 21 },
      { key: 'photo_id_image_url', label: 'Photo ID', enabled: true, order: 22 },
      { key: 'signature_url', label: 'Signature', enabled: true, order: 23 },
      { key: 'signature_name', label: 'Signed By', enabled: true, order: 24 },
      { key: 'signature_date', label: 'Sig Date', enabled: true, order: 25 },
      { key: 'technician_signature', label: 'Tech Signature', enabled: true, order: 26 },
      { key: 'technician_name', label: 'Verified By', enabled: true, order: 27 },
      { key: 'technician_signed_at', label: 'Verified Date', enabled: true, order: 28 },
  ]);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const toggleField = (key: string) => {
    setFields(fields.map(f => f.key === key ? { ...f, enabled: !f.enabled } : f));
  };

  const moveField = (key: string, direction: 'up' | 'down') => {
    const idx = fields.findIndex(f => f.key === key);
    if (direction === 'up' && idx > 0) {
      const newFields = [...fields];
      [newFields[idx], newFields[idx - 1]] = [newFields[idx - 1], newFields[idx]];
      setFields(newFields.map((f, i) => ({ ...f, order: i })));
    } else if (direction === 'down' && idx < fields.length - 1) {
      const newFields = [...fields];
      [newFields[idx], newFields[idx + 1]] = [newFields[idx + 1], newFields[idx]];
      setFields(newFields.map((f, i) => ({ ...f, order: i })));
    }
  };

  const resetTemplate = () => {
    const defaults = [
      { key: 'job_number', label: 'Job Number', enabled: true, order: 0 },
      { key: 'customer_name', label: 'Customer Name', enabled: true, order: 1 },
      { key: 'company_name', label: 'Company', enabled: true, order: 2 },
      { key: 'address', label: 'Address', enabled: false, order: 3 },
      { key: 'region', label: 'Region', enabled: false, order: 4 },
      { key: 'postcode', label: 'Postcode', enabled: true, order: 5 },
      { key: 'customer_type', label: 'Type', enabled: true, order: 6 },
      { key: 'customer_email', label: 'Email', enabled: false, order: 7 },
      { key: 'customer_phone', label: 'Phone', enabled: false, order: 8 },
      { key: 'vehicle_reg', label: 'Vehicle Reg', enabled: true, order: 9 },
      { key: 'vehicle_make', label: 'Make', enabled: false, order: 10 },
      { key: 'vehicle_model', label: 'Model', enabled: false, order: 11 },
      { key: 'vehicle_vin', label: 'VIN', enabled: false, order: 12 },
      { key: 'vehicle_colour', label: 'Colour', enabled: false, order: 13 },
      { key: 'service_type', label: 'Service', enabled: true, order: 14 },
      { key: 'quantity', label: 'Qty', enabled: false, order: 15 },
      { key: 'issue', label: 'Description', enabled: true, order: 16 },
      { key: 'price', label: 'Price', enabled: true, order: 17 },
      { key: 'status', label: 'Status', enabled: true, order: 18 },
      { key: 'created_at', label: 'Date', enabled: true, order: 19 },
      { key: 'gps_lat', label: 'GPS Coords', enabled: true, order: 20 },
      { key: 'v5c_image_url', label: 'V5C Image', enabled: true, order: 21 },
      { key: 'photo_id_image_url', label: 'Photo ID', enabled: true, order: 22 },
      { key: 'signature_url', label: 'Signature', enabled: true, order: 23 },
      { key: 'signature_name', label: 'Signed By', enabled: true, order: 24 },
      { key: 'signature_date', label: 'Sig Date', enabled: true, order: 25 },
      { key: 'technician_signature', label: 'Tech Signature', enabled: true, order: 26 },
      { key: 'technician_name', label: 'Verified By', enabled: true, order: 27 },
      { key: 'technician_signed_at', label: 'Verified Date', enabled: true, order: 28 },
    ];
    setFields(defaults);
  };

  const saveTemplate = async () => {
    setSaving(true);
    setMessage('');
    try {
      const template = { fields: fields.filter(f => f.enabled).sort((a, b) => a.order - b.order) };
      await fetch('/api/tenant/pdf-template', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ template })
      });
      setMessage('✅ Template saved successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ Failed to save template');
    } finally {
      setSaving(false);
    }
  };

  const loadTemplate = async () => {
    try {
      const res = await fetch('/api/tenant/pdf-template', {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (res.ok) {
        const data = await res.json();
        if (data.template && data.template.fields) {
          setFields(data.template.fields);
        }
      }
    } catch (err) { console.error(err); }
  };

  React.useEffect(() => { loadTemplate(); }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '22px' }}>📄 PDF Layout Designer</h2>
          <p style={{ margin: '4px 0 0', color: '#666', fontSize: '14px' }}>Toggle fields on/off and drag to reorder</p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={saveTemplate} disabled={saving} style={{ padding: '10px 20px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
            {saving ? '💾 Saving...' : '💾 Save Template'}
          </button>
          <button onClick={resetTemplate} style={{ padding: '10px 20px', background: '#e2e8f0', color: '#334155', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>🔄 Reset</button>
        </div>
      </div>

      {message && (
        <div style={{ padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', background: message.includes('✅') ? '#d1fae5' : '#fee2e2', color: message.includes('✅') ? '#065f46' : '#991b1b', fontWeight: '500' }}>
          {message}
        </div>
      )}

      <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <div style={{ background: '#f8fafc', padding: '12px 16px', borderBottom: '1px solid #e2e8f0', display: 'flex', fontWeight: '600', fontSize: '13px', color: '#64748b' }}>
          <span style={{ width: '40px' }}>#</span>
          <span style={{ flex: 1 }}>Field</span>
          <span style={{ width: '80px', textAlign: 'center' }}>Move</span>
          <span style={{ width: '80px', textAlign: 'center' }}>Show</span>
        </div>
        
        {fields.sort((a, b) => a.order - b.order).map((field, index) => (
          <div key={field.key} style={{ 
            padding: '12px 16px', 
            borderBottom: '1px solid #f1f5f9', 
            display: 'flex', 
            alignItems: 'center',
            background: field.enabled ? 'white' : '#fafafa',
            transition: 'background 0.2s'
          }}>
            <span style={{ width: '40px', color: '#94a3b8', fontSize: '13px' }}>{index + 1}</span>
            <span style={{ flex: 1, fontWeight: field.enabled ? '500' : '400', color: field.enabled ? '#1e293b' : '#94a3b8', fontSize: '14px' }}>
              {field.enabled ? '👁️ ' : '🚫 '}{field.label}
              {['v5c_image_url', 'photo_id_image_url', 'signature_url'].includes(field.key) && ' 🖼️'}
            </span>
            <div style={{ width: '80px', display: 'flex', gap: '4px', justifyContent: 'center' }}>
              <button onClick={() => moveField(field.key, 'up')} disabled={index === 0} style={{ padding: '4px 8px', border: '1px solid #e2e8f0', borderRadius: '4px', background: 'white', cursor: index === 0 ? 'default' : 'pointer', opacity: index === 0 ? 0.3 : 1, fontSize: '14px' }}>▲</button>
              <button onClick={() => moveField(field.key, 'down')} disabled={index === fields.length - 1} style={{ padding: '4px 8px', border: '1px solid #e2e8f0', borderRadius: '4px', background: 'white', cursor: index === fields.length - 1 ? 'default' : 'pointer', opacity: index === fields.length - 1 ? 0.3 : 1, fontSize: '14px' }}>▼</button>
            </div>
            <div style={{ width: '80px', textAlign: 'center' }}>
              <button onClick={() => toggleField(field.key)} style={{
                padding: '6px 16px',
                borderRadius: '20px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '13px',
                background: field.enabled ? '#d1fae5' : '#fee2e2',
                color: field.enabled ? '#065f46' : '#991b1b',
                transition: 'all 0.2s'
              }}>
                {field.enabled ? 'ON' : 'OFF'}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: '24px', background: '#eff6ff', padding: '16px', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
        <p style={{ margin: 0, fontSize: '13px', color: '#1e40af' }}>
          💡 <strong>How it works:</strong> Toggle fields ON/OFF to include or exclude them from PDF reports. 
          Use ▲▼ to reorder. Click <strong>Save Template</strong> when done. 
          Your next PDF will use this layout!
        </p>
      </div>
    </div>
  );
};


const ServicesManager: React.FC<{ token: string; onServiceSelect?: (s: any) => void }> = ({ token, onServiceSelect }) => {
  const [services, setServices] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState<any>(null);
  const [form, setForm] = useState({ name: '', description: '', price: 0 });
  const [loading, setLoading] = useState(false);

  const loadServices = async () => {
    try {
      const res = await fetch('/api/services', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setServices(await res.json());
    } catch (e) { console.error(e); }
  };

  React.useEffect(() => { loadServices(); }, []);

  const saveService = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const url = editing ? `/api/services/${editing.id}` : '/api/services';
      const method = editing ? 'PUT' : 'POST';
      const body = editing ? { ...form, active: true } : form;
      await fetch(url, { method, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify(body) });
      setShowForm(false); setEditing(null); setForm({ name: '', description: '', price: 0 });
      loadServices();
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const deleteService = async (id: string) => {
    if (!window.confirm('Delete this service?')) return;
    await fetch(`/api/services/${id}`, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    loadServices();
  };

  const editService = (s: any) => {
    setEditing(s);
    setForm({ name: s.name, description: s.description || '', price: parseFloat(s.price) || 0 });
    setShowForm(true);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
        <h1 style={{ fontSize: '20px', margin: 0 }}>🔧 Services</h1>
        <button onClick={() => { setEditing(null); setForm({ name: '', description: '', price: 0 }); setShowForm(!showForm); }} style={{ padding: '8px 16px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
          {showForm ? 'Cancel' : '+ Add Service'}
        </button>
      </div>

      {showForm && (
        <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: '16px' }}>{editing ? 'Edit Service' : 'New Service'}</h3>
          <form onSubmit={saveService}>
            <div style={{ marginBottom: '10px' }}>
              <label style={{ fontSize: '13px', fontWeight: '500' }}>Service Name *</label>
              <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} placeholder="e.g. Lost Keys, Replacement Key" />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label style={{ fontSize: '13px', fontWeight: '500' }}>Description</label>
              <input type="text" value={form.description} onChange={e => setForm({...form, description: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label style={{ fontSize: '13px', fontWeight: '500' }}>Price (£)</label>
              <input type="number" value={form.price} onChange={e => setForm({...form, price: parseFloat(e.target.value) || 0})} step="0.01" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
            </div>
            <button type="submit" disabled={loading} style={{ width: '100%', padding: '10px', background: '#2a5298', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
              {loading ? 'Saving...' : editing ? 'Update Service' : 'Add Service'}
            </button>
          </form>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {services.map(s => (
          <div key={s.id} style={{ background: 'white', borderRadius: '12px', padding: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
            <div>
              <strong style={{ fontSize: '15px' }}>{s.name}</strong>
              {s.description && <div style={{ fontSize: '12px', color: '#666' }}>{s.description}</div>}
              <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#2a5298', marginTop: '4px' }}>£{parseFloat(s.price).toFixed(2)}</div>
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
              {onServiceSelect && (
                <button onClick={() => onServiceSelect(s)} style={{ padding: '6px 12px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Use</button>
              )}
              <button onClick={() => editService(s)} style={{ padding: '6px 12px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>✏️</button>
              <button onClick={() => deleteService(s.id)} style={{ padding: '6px 12px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>🗑️</button>
            </div>
          </div>
        ))}
        {services.length === 0 && <div style={{ textAlign: 'center', padding: '40px', background: 'white', borderRadius: '12px', color: '#999' }}>No services yet. Add your first service!</div>}
      </div>
    </div>
  );
};


export default TechnicianPortal;
